import { render, staticRenderFns } from "./ButtonsCounter.vue?vue&type=template&id=0417e071"
import script from "./ButtonsCounter.vue?vue&type=script&lang=js"
export * from "./ButtonsCounter.vue?vue&type=script&lang=js"
import style0 from "./ButtonsCounter.vue?vue&type=style&index=0&id=0417e071&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports